import { consumerAutoAddressEpics } from '../components/consumer-address-view/modules/consumer-auto-address/store/consumer-auto-address.epics'
import { consumerManualAddressEpics } from '../components/consumer-address-view/modules/consumer-manual-address/store/consumer-manual-address.epics'

export const consumerAddressStepEpics = [
  ...consumerAutoAddressEpics,
  ...consumerManualAddressEpics
]
